import { render, staticRenderFns } from "./RuleForm.vue?vue&type=template&id=6bb70590&"
import script from "./RuleForm.vue?vue&type=script&lang=js&"
export * from "./RuleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports